var Model = require('../../core/model');

/**
 * Model for a category
 */
module.exports = Model.extend({

  defaults: {
    name: '',
    agg: false,
    value: 0
  }

});



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/dataviews/category-dataview/category-item-model.js
// module id = 1523
// module chunks = 6